import { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { logError, logRequest, logResponse } from "../use-api-logging";
import { ErrorDto } from "@/api-connector/play-digital-api/models/shared-models";

const logRequestInternal = (config: InternalAxiosRequestConfig) => {
    try {
        logRequest(config);
    } catch (err) {
        console.error("Api logging error", err);
    }
    return config;
};

const logResponseInternal = (response: AxiosResponse) => {
    try {
        logResponse(response);
    } catch (err) {
        console.error("API logging error", err);
    }

    if (response) return response;
};

const logErrorInternal = (error: AxiosError<ErrorDto>) => {
    try {
        logError(error);
    } catch (err) {
        console.error("API logging error", err, error);
    }
    return Promise.reject(error);
};

/* eslint-disable */
export const addLoggerInterceptor = (httpClient: AxiosInstance) => {
    // @ts-ignore
    httpClient.interceptors.request.use(logRequestInternal, logErrorInternal);
    httpClient.interceptors.response.use(logResponseInternal, logErrorInternal);
};
